import { useCallback, useEffect, useState } from "react";

import {
  defaultApi,
  type PersonalCustomEmoji,
  type PersonalCustomEmojiSet
} from "../../api/client";

export type CustomEmojiLibraryApi = Pick<
  typeof defaultApi,
  "loadCustomEmojiSets" | "loadRecentCustomEmoji" | "markCustomEmojiUsed" | "loadCustomEmojiPreview"
>;

export function useCustomEmojiLibrary(api: CustomEmojiLibraryApi = defaultApi) {
  const [sets, setSets] = useState<PersonalCustomEmojiSet[]>([]);
  const [recent, setRecent] = useState<PersonalCustomEmoji[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const [nextSets, nextRecent] = await Promise.all([
        api.loadCustomEmojiSets(),
        api.loadRecentCustomEmoji()
      ]);
      setSets(nextSets);
      setRecent(nextRecent);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => { void refresh().catch(() => undefined); }, [refresh]);

  const markUsed = useCallback(async (emoji: PersonalCustomEmoji) => {
    setRecent((items) => [emoji, ...items.filter((item) => item.customEmojiId !== emoji.customEmojiId)].slice(0, 40));
    await api.markCustomEmojiUsed(emoji.customEmojiId).catch(() => undefined);
  }, [api]);

  return {
    sets,
    recent,
    loading,
    refresh,
    markUsed,
    loadPreview: api.loadCustomEmojiPreview
  };
}

